import type { Ref } from 'vue'
import { CellGroup, Field } from 'vant'

// 「图形验证码 + 短信验证码」输入行，注册 / 找回密码 / 更换手机号共用

interface SmsCodeFieldsOptions {
  captchaInput: Ref<string>
  code: Ref<string>
  captchaImage: string
  refreshCaptcha: () => void
  /** 「获取验证码」按钮上的文字（倒计时中显示秒数） */
  codeButtonText: string
  onGetCode: () => void
}

/** 注册 / 找回密码：带标签的手机号、图形验证码、短信验证码三行 */
export function renderPhoneSmsFields(opts: SmsCodeFieldsOptions & { phone: Ref<string> }) {
  const { phone, captchaInput, code } = opts
  return (
    <>
      <Field
        v-model={phone.value}
        label="用户名"
        placeholder="请输入11位手机号"
        maxlength={11}
        type="tel"
        formatter={(v: string) => v.replace(/\D/g, '').slice(0, 11)}
      />

      <Field
        v-model={captchaInput.value}
        center
        label="图形验证码"
        placeholder="输入图形验证码"
        maxlength={6}
      >
        {{
          'right-icon': () => (
            <button type="button" class="btn-reset" aria-label="刷新验证码" onClick={opts.refreshCaptcha}>
              <img src={opts.captchaImage} class="h-[0.6rem] cursor-pointer" alt="captcha" />
            </button>
          ),
        }}
      </Field>

      <Field v-model={code.value} label="验证码" placeholder="输入验证码" maxlength={6}>
        {{
          'right-icon': () => (
            <button type="button" class="get-code btn-reset" onClick={opts.onGetCode}>
              {opts.codeButtonText}
            </button>
          ),
        }}
      </Field>
    </>
  )
}

/** 更换手机号两步页：图形验证码、短信验证码各一组 */
export function renderSmsCodeGroups(opts: SmsCodeFieldsOptions) {
  const { captchaInput, code } = opts
  return (
    <>
      <CellGroup class="mar-top">
        <Field v-model={captchaInput.value} maxlength={6} placeholder="输入图形验证码">
          {{
            'right-icon': () => (
              <button type="button" class="btn-reset" aria-label="刷新验证码" onClick={opts.refreshCaptcha}>
                <img src={opts.captchaImage} class="h-[0.56rem] w-[1.6rem] cursor-pointer" alt="验证码" />
              </button>
            ),
          }}
        </Field>
      </CellGroup>

      <CellGroup class="mar-top">
        <Field v-model={code.value} placeholder="请输入验证码">
          {{
            'right-icon': () => (
              <button type="button" class="get-code btn-reset cursor-pointer" onClick={opts.onGetCode}>
                {opts.codeButtonText}
              </button>
            ),
          }}
        </Field>
      </CellGroup>
    </>
  )
}
